/** Translated strings (en / fr / es) for `LeadTimesZipCode.tsx`. */
import { LanguageContent } from "@ryerson/frontend.common";

/**
 * The strings each language of {@link LeadTimesZipContent} must provide. These are content
 * strings, not the props of the `LeadTimesZipCode` component.
 */
export interface LeadTimesZipProps {
	showPricesAndLeadTimes: string;
	apply: string;
	customerPickUp: string;
	locationUpdated: string;
	/** Shown when the e-commerce provider reports `isValidZipCode` false. */
	validZipCode: string;
}

/** Zip-code control strings, keyed by language. */
export const LeadTimesZipContent: LanguageContent<LeadTimesZipProps> = {
	en: {
		showPricesAndLeadTimes: "Show prices & lead time for:",
		apply: "Apply",
		customerPickUp: "Customer Pick Up",
		locationUpdated: "Location updated",
		validZipCode: "We currently cannot ship to this zip code",
	},
	fr: {
		showPricesAndLeadTimes: "Afficher les prix et les délais pour:",
		apply: "Appliquer",
		customerPickUp: "Cueillette",
		locationUpdated: "Emplacement mis à jour",
		validZipCode: "Nous ne pouvons actuellement pas expédier vers ce code postal",
	},
	es: {
		showPricesAndLeadTimes: "Mostrar precios y plazo de entrega para:",
		apply: "Aplicar",
		customerPickUp: "El cliente acude por el producto",
		locationUpdated: "Ubicacion actalizada",
		validZipCode: "Actualmente no podemos enviar a este código postal",
	},
};
